var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._b(
      {
        staticClass: "layout_container_main",
        style: {
          height: _vm.height && _vm.height + "px",
          "max-height": _vm.height && _vm.height + "px"
        },
        attrs: { "data-v-step": "videos" }
      },
      "div",
      _vm._d({}, [_vm.state.layoutAttr, true])
    ),
    [
      _c("div", { staticClass: "row kanban-header rounded" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            { staticClass: "h-100 d-inline-flex align-items-center" },
            [
              _vm.state.loading ? [_vm._m(0)] : _vm._e(),
              _vm._v("\n        " + _vm._s(_vm.title) + "\n        "),
              _vm.state.archived
                ? _c("span", { staticClass: "ml-2" }, [
                    _vm._v(
                      "\n                      [" +
                        _vm._s(_vm.$t("txtArchiveView")) +
                        "]\n                  "
                    )
                  ])
                : _vm.state.templatesView
                ? _c("span", { staticClass: "ml-2" }, [
                    _vm._v(
                      "\n                      [" +
                        _vm._s(_vm.$t("kanbanTemplates")) +
                        "]\n                  "
                    )
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "float-right" },
            [
              _vm.state.openApprovals.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-warning",
                      attrs: {
                        title: _vm.$t("kanban.approval.menu.listApprovals")
                      },
                      on: {
                        click: function($event) {
                          return _vm.$refs.modalContainer.openListApprovals()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-signature" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.state.settings &&
              _vm.state.settings.advancedUi &&
              !_vm.state.archived
                ? _c(
                    "button",
                    {
                      staticClass: "btn",
                      class: {
                        "btn-secondary": !_vm.state.templatesView,
                        "btn-primary": _vm.state.templatesView
                      },
                      attrs: { title: _vm.$t("kanbanTemplates") },
                      on: {
                        click: function($event) {
                          _vm.state.templatesView = !_vm.state.templatesView
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-file" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.state.settings &&
              _vm.state.settings.advancedUi &&
              _vm.state.selectedBoard &&
              !_vm.isInbox(_vm.state.selectedBoard)
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { title: _vm.$t("kanbanAttributes") },
                      on: {
                        click: function($event) {
                          return _vm.$refs.modalContainer.openAttributeDefinitions(
                            _vm.state.selectedBoard
                          )
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-asterisk" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.state.settings && _vm.state.settings.advancedUi
                ? [
                    _vm.state.massSelectionEnabled
                      ? _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" }
                            },
                            [
                              _c("i", { staticClass: "fa fa-check-square" }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.state.massSelectionCards.length) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            staticClass:
                              "btn btn-secondary dropdown-toggle dropdown-toggle-split",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false",
                              id: "massSelectButton"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dowpdown-menu-kanban",
                              attrs: { "aria-labelledby": "massSelectButton" }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item c-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.modalContainer.openResponsible()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("kanbanResponsibles")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item c-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.modalContainer.openConfirmMassSelectArchive()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("kanban.menu.massSelect.archive")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item c-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.modalContainer.openConfirmMassSelectDelete()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("kanban.menu.massSelect.delete")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item c-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.modalContainer.openConfirmMassSelectPdf()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("kanban.menu.massSelect.pdf"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.canRequestApproval
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item c-pointer",
                                      class: {
                                        disabled: !_vm.areMassSelectedCardsWithin1Board
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs.modalContainer.openRequestApproval()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "kanban.approval.menu.requestApproval"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      !_vm.areMassSelectedCardsWithin1Board
                                        ? _c("span", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "kanban.approval.menu.onlyWithin1Board"
                                                  )
                                                ) +
                                                ")"
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item c-pointer",
                                  on: {
                                    click: function($event) {
                                      _vm.state.massSelectionEnabled = false
                                      _vm.state.massSelectionCards.splice(0)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("kanbanCancel")))]
                              )
                            ]
                          )
                        ])
                      : _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { title: _vm.$t("kanbanMassSelect") },
                            on: {
                              click: function($event) {
                                _vm.state.massSelectionEnabled = true
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-check-square" })]
                        )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { title: _vm.$t("kanbanReload") },
                  on: {
                    click: function($event) {
                      return _vm.$emit("reload")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-sync" }),
                  _vm._v(" "),
                  _vm.state.updates > 0
                    ? _c("span", { staticClass: "badge badge-warning" }, [
                        _vm._v(
                          "\n                          " +
                            _vm._s(_vm.state.updates) +
                            "\n                      "
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { title: _vm.$t("History"), "data-v-step": "history" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.modalContainer.openActivityLog()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-history" })]
              )
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row m-1" }, [
        !_vm.state.loading
          ? _c(
              "div",
              { staticClass: "btn-toolbar", attrs: { role: "toolbar" } },
              [
                _vm._l(_vm.boardsToDisplay, function(board) {
                  return _c("div", { key: board.id }, [
                    _vm.editBoardId !== board.id
                      ? _c(
                          "div",
                          {
                            staticClass: "btn-group m-1",
                            attrs: { role: "group" }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                class: [
                                  _vm.state.selectedBoard &&
                                  _vm.state.selectedBoard.id === board.id
                                    ? "active"
                                    : ""
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.click(board)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(board.name) +
                                    "\n            "
                                ),
                                _vm.isOwn(board)
                                  ? _c(
                                      "span",
                                      { staticClass: "badge badge-light" },
                                      [
                                        _vm.state.templatesView
                                          ? _c("i", {
                                              staticClass: "fas fa-user",
                                              attrs: {
                                                title: _vm.$t(
                                                  "kanbanOwnTemplate"
                                                )
                                              }
                                            })
                                          : _c("i", {
                                              staticClass: "fas fa-user",
                                              attrs: {
                                                title: _vm.$t("kanbanOwnBoard")
                                              }
                                            })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isPrivate(_vm.state, board) &&
                                !_vm.state.templatesView
                                  ? _c(
                                      "span",
                                      { staticClass: "badge badge-light" },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-lock",
                                          attrs: { title: _vm.$t("txtPrivate") }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.state.settings &&
                                _vm.state.settings.alwaysShowMyBoards
                                  ? [
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("small", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              "(" +
                                                _vm.getAccountName(
                                                  _vm.state,
                                                  board.fkAccountId
                                                ) +
                                                ")"
                                            ) +
                                            " "
                                        )
                                      ])
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: { "data-v-step": "boardoptions" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.onBoardOptionsMenuOpen(
                                      $event,
                                      board
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-ellipsis-v",
                                  attrs: { title: _vm.$t("txtOptions") }
                                })
                              ]
                            )
                          ]
                        )
                      : _c("div", { staticClass: "input-group m-1" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.editBoardName,
                                expression: "editBoardName"
                              }
                            ],
                            ref: "editboardname",
                            refInFor: true,
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.editBoardName },
                            on: {
                              keyup: [
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.renameBoard(board)
                                },
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "esc",
                                      27,
                                      $event.key,
                                      ["Esc", "Escape"]
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  _vm.editBoardId = null
                                  _vm.editBoardName = null
                                }
                              ],
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.editBoardName = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group-append" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.renameBoard(board)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("btnRename")) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.editBoardId = null
                                    _vm.editBoardName = null
                                  }
                                }
                              },
                              [_vm._v("\n              ×\n            ")]
                            )
                          ])
                        ])
                  ])
                }),
                _vm._v(" "),
                _c("vue-simple-context-menu", {
                  ref: "boardOptionsContextMenu",
                  attrs: {
                    elementId: "boardOptionsContextMenu",
                    options: _vm.boardOptionsContextMenuOptionsFiltered
                  },
                  on: { "option-clicked": _vm.onBoardOptionsContextMenuClicked }
                }),
                _vm._v(" "),
                !_vm.state.archived && !_vm.state.templatesView
                  ? [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.newBoard === null,
                              expression: "newBoard === null"
                            }
                          ],
                          staticClass: "btn-group m-1",
                          attrs: { role: "group", "data-v-step": "newboard" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              on: {
                                click: function($event) {
                                  _vm.newBoard = ""
                                  _vm.$nextTick(function() {
                                    _vm.$refs.newboard.focus()
                                  })
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-plus",
                                attrs: { title: _vm.$t("txtNewBoard") }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.newBoard !== null,
                              expression: "newBoard !== null"
                            }
                          ],
                          staticClass: "input-group m-1"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newBoard,
                                expression: "newBoard"
                              }
                            ],
                            ref: "newboard",
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.newBoard },
                            on: {
                              keyup: [
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.createBoard.apply(null, arguments)
                                },
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "esc",
                                      27,
                                      $event.key,
                                      ["Esc", "Escape"]
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  _vm.newBoard = null
                                }
                              ],
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.newBoard = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group-append" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: { click: _vm.createBoard }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("btnCreate")) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.$refs.modalContainer.openBoardCreateModal(
                                      _vm.newBoard
                                    )
                                    _vm.newBoard = null
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("kanbanTemplate")) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.newBoard = null
                                  }
                                }
                              },
                              [_vm._v("×")]
                            )
                          ])
                        ]
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          : _c("div", { staticClass: "d-flex justify-content-center w-100" }, [
              _vm._m(1)
            ])
      ]),
      _vm._v(" "),
      !_vm.state.loading && _vm.state.accounts
        ? _vm._l(_vm.boardsToDisplay, function(board) {
            return _c("kanban-board", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.state.selectedBoard &&
                    _vm.state.selectedBoard.id === board.id,
                  expression:
                    "state.selectedBoard && state.selectedBoard.id === board.id"
                }
              ],
              key: board.id,
              attrs: { state: _vm.state, board: board },
              on: {
                reload: function($event) {
                  return _vm.$emit("reload")
                },
                "flow-created": _vm.startTour,
                openCard: _vm.openCard,
                openPort: function($event) {
                  return _vm.$refs.modalContainer.openPort(
                    $event.board,
                    $event.flow
                  )
                }
              }
            })
          })
        : _vm._e(),
      _vm._v(" "),
      _c("v-tour", {
        attrs: {
          name: "InitialTour",
          steps: _vm.tour.tourInitialSteps(_vm.$i18n.locale)
        }
      }),
      _vm._v(" "),
      _c("v-tour", {
        attrs: {
          name: "BoardExistsTour",
          steps: _vm.tour.tourBoardExistsSteps(_vm.$i18n.locale)
        }
      }),
      _vm._v(" "),
      _c("v-tour", {
        attrs: {
          name: "FlowExistsTour",
          steps: _vm.tour.tourFlowExistsSteps(_vm.$i18n.locale)
        }
      }),
      _vm._v(" "),
      _c("modal-container", {
        ref: "modalContainer",
        attrs: { state: _vm.state, responsibles: _vm.responsibles },
        on: {
          logSelected: function($event) {
            return _vm.logSelected($event)
          },
          addResponsible: _vm.responsibleAdd,
          removeResponsible: _vm.responsibleRemove,
          addBoardShared: _vm.sharedAdd,
          removeBoardShared: _vm.sharedRemove,
          "save-lockdown-delay": _vm.saveLockdownDelay,
          "create-board": function($event) {
            return _vm.createBoardWithNameAndTemplate(
              $event.name,
              $event.templateId
            )
          },
          reload: _vm.state.reloadAll
        }
      }),
      _vm._v(" "),
      _c("ChangeBoardOwnerModal", {
        ref: "changeBoardOwnerModal",
        attrs: { state: _vm.state }
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "spinner-border spinner-border-sm",
        attrs: { role: "status" }
      },
      [_c("span", { staticClass: "sr-only" })]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "spinner-border text-secondary",
        attrs: { role: "status" }
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }